import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { SessionService } from '../services/session.service';

// Route guard for the AI Summary page. Mirrors SuperAdminGuard: session.user is populated by
// the APP_INITIALIZER (settingsFactory) before any route activates, so this holds up on a hard
// refresh straight to /ai-summaries.
//
// A super-admin always gets through (they can see the whole portal). For everyone else the
// per-user AI Summary switch IS the permission — no role required, so a customer stays on the
// plain 'user' role instead of being promoted to admin just to read their own call summaries.
@Injectable({ providedIn: 'root' })
export class AiSummaryGuard {
  constructor(private router: Router, private session: SessionService) {}

  canActivate(): boolean | UrlTree {
    const user = this.session.user;

    if ((user?.roles || []).includes('superadmin')) return true;
    if (user?.aiSummaryEnabled) return true;

    return this.router.parseUrl('/dashboard');
  }
}
